
import TwoRow3 from '@/components/Common/Layout/Table/TwoRow3'

export default {
    name: 'SectorDetail',
    components: {
        TwoRow3,
    },
    props: {
        data: Array,
    },
    methods: {
        stocksToList(item) {
            const list = item.split(',')
            const stocksList = []
            console.log("listtttgtgggtgggg "+list)
            for (const stock of list) {
                const splitStock = stock.split(':')
                const code = splitStock[0]
                const name = splitStock[1]
                /* 
                  220519 meej 관련종목 조건 추가
                */
                if(code !== '' && code !== null && name !== '' && name !== null){
                  stocksList.push({ code, name })
                }
            }
            return stocksList
        },
        onClickStock(code) {
            const routeData = this.$router.resolve({
                name: `/stockitem?code=${code}`,
            })
            window.open(
                routeData.location.name,
                'StockItem',
                'width=1200px,height=1000,scrollbars=1,resizable=yes'
            )
        },
    },
}
